import React from "react";
import { Button, Col, Container, FormLabel, Row } from "react-bootstrap";
import {
  InventoryLocationTransferSearchCriteria,
  PageListBean,
  RestInventoryTransferListRequest,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import { isEmptyString } from "../gui_components/Util.js";
import { InventoryService } from "../services/InventoryService.js";
export class InventoryTransferLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    let resetCriteria = new InventoryLocationTransferSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let inventoryTransferLookupCriteria =
      new InventoryLocationTransferSearchCriteria();
    inventoryTransferLookupCriteria.companyCode = this.companyCode;
    let newCriteria = new InventoryLocationTransferSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let lookupCriteriaView = InventoryTransferLookupCriteraHandler(
      companyCode,
      inventoryTransferLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      inventoryTransferLookupCriteria,
      lookupCriteriaView
    );
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition(" Reason", "transferReason", 0, false); //1
    this.addColumnDefinition("DocumentType", "documentType", 0, false); //3
    this.addColumnDefinition("DocumentNumber", "documentNumber", 0, false); //3
    this.addColumnDefinition("CreatedDate", "createdDate", 0, false);
  }
  loadInventoryTransferList = (lookup_dialog, pageNumber, searchCriteria) => {
    let transfer_criteria = new InventoryLocationTransferSearchCriteria(); //To be fetched from CriteriaHandler
    transfer_criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      transfer_criteria.transferCode = searchCriteria.transferCode;
      transfer_criteria.transferReason = searchCriteria.transferReason;
      transfer_criteria.toLocationCode = searchCriteria.toLocationCode;
      transfer_criteria.fromLocationCode = searchCriteria.fromLocationCode;
    }
    let transfer_pageList = new PageListBean();
    transfer_pageList.pageSize = 50; //TODO --> Fetch from Config
    transfer_pageList.pageNumber = pageNumber;
    transfer_pageList.currentPage = pageNumber;
    let transfer_requestInput = new RestInventoryTransferListRequest();
    transfer_requestInput.pageInput = transfer_pageList;
    transfer_requestInput.searchCriteria = transfer_criteria;
    InventoryService.getInventoryLocationTransferPageList(
      transfer_requestInput,
      (response) =>
        this.loadInventoryTransferListResponse(response, lookup_dialog),
      this.loadInventoryTransferListError
    );
  };
  loadInventoryTransferListResponse = (response, lookup_dialog) => {
    let transferList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.inventoryLocationTransferPageList != null &&
      response.data.inventoryLocationTransferPageList
        .inventoryLocationTransfers !== null
    ) {
      transferList =
        response.data.inventoryLocationTransferPageList
          .inventoryLocationTransfers;
      totalCount = response.data.inventoryLocationTransferPageList.totalCount;
      currentPageNumber =
        response.data.inventoryLocationTransferPageList.currentPage;
      pageSize = response.data.inventoryLocationTransferPageList.pageSize;
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = transferList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadInventoryTransferListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.transferCode)) {
      if (!isEmptyString(filterText)) {
        search.transferCode = filterText;
        this.searchCriteria = new InventoryLocationTransferSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadInventoryTransferList(lookup_dialog, pageNumber, search);
    }
  }
}
const InventoryTransferLookupCriteraHandler = (
  companyCode,
  inventoryTransferLookupCriteria
) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new InventoryLocationTransferSearchCriteria(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    }
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new InventoryLocationTransferSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>Transfer Code </FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="transferCode"
                  name="transferCode"
                  onChange={this.onChange}
                  value={searchCriteria.transferCode}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>TransferReason</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="transferReason"
                  name="transferReason"
                  onChange={this.onChange}
                  value={searchCriteria.transferReason}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>FromLocationCode</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="fromLocationCode"
                  name="fromLocationCode"
                  onChange={this.onChange}
                  value={searchCriteria.fromLocationCode}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>ToLocationCode</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="toLocationCode"
                  name="toLocationCode"
                  onChange={this.onChange}
                  value={searchCriteria.toLocationCode}
                />
              </Col>
            </Row>
            <div className="popup_criteria_button_align-lookup">
              <Button
                ref={this.focusRef}
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </div>
          </Container>
        </div>
      );
    }
  };
};
